/**
 * Auth Module Exports
 * Central export point for authentication functionality
 */

// === AUTH FUNCTIONS ===
export { login, logout, resetPassword } from './auth';

// === AUTH UTILITIES ===
export {
  getAuthConfigFromStore,
  isAuthConfigured,
  isAuthConfigValid,
  getAuthHeaders,
  getAuthErrorMessage
} from './authUtils';

// === STORE ===
export { useAuthStore } from '../store/authStore';

// === TYPES ===
export type { AuthConfig } from './authUtils';

// === VERSION INFO ===
export const AUTH_MODULE_VERSION = '1.0.0';
export const AUTH_MODULE_NAME = 'FleetA Authentication Module';